import sensors from 'sa-sdk-javascript'
import merge from 'merge'
import { SensorsConfig } from './SensorsConfig'
  
export const initSensors = async ({sensorsOption, option} = new SensorsConfig()) => {

  const { runEnv, project, projectName, personInfo, showLog, projectId = "", personId = ""} = option
  // 生成后端字段需要的token字段
  const token = _createToken()
  // 判断是否是生产
  const isPrd = ['prd', 'PRD', 'prod', 'PROD', 'production'].includes(runEnv)
  // 如果是生产环境，那么接口地址为生产地址，不传默认调QAS
  let server_url = isPrd ? 'https://analysislog.cttq.com': 'https://analysislogqas.cttq.com'
  // 接口地址拼接
  server_url = server_url + `/api/v2/log/allIn.git?token=${token}&project=${project}`
  // 获取设备类型
  const deviceType = _getDeviceType()
  const { chromeVersion, safariVersion, lark, mobile, ios } = deviceType
  // 主要判断设备端：PC，mobile分为：ios和android
  const platform = mobile ?
    ios ? 'IOS' : 'Android'
    : 'PC'
  // personCode 员工工号
  const personCode = personInfo.personCode || personId
  try {
    // 检验初始化参数，如果必填字段未传，会进入到catch中
    await _validateParam(option)
  } catch(e) {
    // 异常提示
    console.error("存在异常："+ e)
    return
  }
  /**
    * 神策：注册页面事件，自定义添加字段
   */
  // V1.3 版本
  sensors.registerPage({
    project: project, // 项目名称
    projectName: projectName, // 项目中文名
    projectId: projectId, //项目ID
    personId: personCode, // 工号
    evtId: '10000001', // 事件ID。$pageView事件默认传入 10000001
    platform, // 设备端
    chromeVersion,
    safariVersion,
    lark,
  });
  const defaultConfig = {
    // 接收日志的地方
    server_url,
    // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
    // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
    // web_url: '',
    heatmap: { // 'not_collect' 关闭当前事件
        scroll_notice_map: 'not_collect', // 视区停留的事件
        clickmap:'not_collect', // 点击事件
    },
    send_type: "beacon",
    is_track_single_page: true,
    // 是否打印log，可以打开确认集成是否OK
    show_log: showLog || false,
    /**
     * 是否批量传送
     * 1. 当前传送失败会转到下一个
     * 2. 会先存储到localStorage,然后再上传，上传成功后会删除localStorage
     * 3. 重复机制：失败会一直轮询
     */
    batch_send: true,
    // 内置的参数可以删除部分
    preset_properties: {
      latest_referrer_host:false,
      latest_referrer: false,
      latest_search_keyword: false,
      latest_utm: false,
      latest_traffic_source_type: false,
    }
  }

  sensors.init(merge.recursive(true, defaultConfig, sensorsOption))
  sensors.quick('autoTrack')
  return sensors
}

//获取当前设备端
const _getDeviceType = () => {
  const ua = window.navigator.userAgent
  const uaList = navigator.userAgent.split(" ")
  const chrome_version = uaList.find(item => item.includes("Chrome/"))
  const safari_version = uaList.find(item => item.includes("Version/"))
  const lark_version = uaList.find(item => item.includes("Lark/"))
  let chromeVersion = '-'
  let safariVersion = '-'
  let lark = '-'
  if(chrome_version) {
    chromeVersion = chrome_version.split("Chrome/")[1]
  }
  if(safari_version){
    safariVersion = safari_version.split("Version/")[1]
  }
  if(lark_version) {
    lark = lark_version.split("Lark/")[1]
  }
  return {
    mobile: !!ua.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1, // android终端或者uc浏览器
    chromeVersion,
    safariVersion,
    lark
  }
}

// 验证参数
// 目前需要调用方传入：
/*
* @param {String} projectName 项目Id
* @param {String/Number} personId 登录系统的id
* @param {String/Number} personInfo 项目id
* @param {String} token 后端接口必传字段，埋点平台生成的传入即可
*/
const _validateParam = (option) => {
  const { project, projectName, personInfo, projectId } = option
  return new Promise((resolve, reject) => {
    if(!project) {
      reject("嘿~是不是忘记传参啦，project（项目英文名称）字段必填哦~")
    }
    if(!projectName) {
      reject("嘿~是不是忘记传参啦，projectName（项目中文名称）字段必填哦~")
    }
    if(!projectId) {
      reject("嘿~是不是忘记传参啦，projectId（项目id）字段必填哦~")
    }
    if(!personInfo || JSON.stringify(personInfo) === '{}') {
      reject("嘿~是不是忘记传参啦，personInfo（登录信息）字段必填哦~")
    }
    resolve()
  })

}
// 随机生成一个uuid
const _createToken = () => {
  var temp_url = URL.createObjectURL(new Blob());
  var uuid = temp_url.toString(); // blob:https://xxx.com/b250d159-e1b6-4a87-9002-885d90033be3
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf("/") + 1);
}
